import { Component, OnInit } from '@angular/core';
import { AbstractDialogComponent } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ipr-promotion-popup-dialog',
  templateUrl: './ipr-promotion-popup-dialog.component.html',
  styleUrls: ['./ipr-promotion-popup-dialog.component.scss'],
})
export class IprPromotionPopupDialogComponent extends AbstractDialogComponent implements OnInit {
  iprContent: string;

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
    if (this.inputs && this.inputs.length > 0) {
      this.iprContent = this.inputs[0];
    }
  }

  onClose(): void {
    this.activeModal.close();
  }
}
